/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_EventInputs */

const en_select_event = /** @type {(inputs: Select_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Event`)
};

const fr_select_event = /** @type {(inputs: Select_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner l’événement`)
};

const de_select_event = /** @type {(inputs: Select_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis auswählen`)
};

const it_select_event = /** @type {(inputs: Select_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona evento`)
};

const ru_select_event = /** @type {(inputs: Select_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите событие`)
};

const es_select_event = /** @type {(inputs: Select_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar evento`)
};

const zh_cn2_select_event = /** @type {(inputs: Select_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择事件`)
};

const ja_select_event = /** @type {(inputs: Select_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを選択`)
};

const hi_select_event = /** @type {(inputs: Select_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट चुनें`)
};

const pt_pt2_select_event = /** @type {(inputs: Select_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o evento`)
};

/**
* | output |
* | --- |
* | "Select Event" |
*
* @param {Select_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_event = /** @type {((inputs?: Select_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_select_event(inputs)
	if (locale === "de") return de_select_event(inputs)
	if (locale === "it") return it_select_event(inputs)
	if (locale === "ru") return ru_select_event(inputs)
	if (locale === "es") return es_select_event(inputs)
	if (locale === "zh-CN") return zh_cn2_select_event(inputs)
	if (locale === "ja") return ja_select_event(inputs)
	if (locale === "hi") return hi_select_event(inputs)
	if (locale === "pt-PT") return pt_pt2_select_event(inputs)
	return en_select_event(inputs)
});